import { graphql } from "../../../services/wp.api.service";

const query = `
query MyCommunicationsQuery($userId: ID!) {
	user(id: $userId, idType: DATABASE_ID) {
	  communicationPreferences {
		contactMethod
		receiveEmail
		receiveSnailMail
	  }
	}
}
`;

export const myCommsPrefsQuery = (useQuery, userId, options) => useQuery(
	["my_comms_preferences"],
	() => graphql({
		query,
		variables: { userId }
	}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}

			return data.data.user?.communicationPreferences || {};
		}),
	{
		staleTime: 1000 * 60 * 10,
		...options
	}
);
